import { useEffect } from "react";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Loader } from "@remo-co/ui-core/src/components/Loader";
import { Popover } from "@remo-co/ui-core/src/components/Popover";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { Warnings, trackWarning } from "modules/monitoring";
import { Colors } from "@remo-co/ui-core/theme";
import { useTicker } from "modules/dateTime";
import { COUNTDOWN_LENGTH } from "modules/shuffleAttendees/constants";
import { useAppDispatch } from "store/hooks";
import { useShuffleStartTime } from "../../hooks/useShuffleStartTime";
import { hideInitShuffleBanner } from "../../redux/actions";

export const SHUFFLE_TIMEOUT = 30;

export const TICKER_INTERVAL = 1000;

export const ShuffleInProgressComponent = () => {
  const { t } = useI18n(["event"]);

  return (
    <Popover
      anchorEl={document.body}
      BackdropProps={{
        color: Colors.DISABLED,
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      open
    >
      <Container size="sm" flex column alignItems="center">
        <Container inline size="sm">
          <Loader
            loaderColor={Colors.BLUE_PRIMARY}
            backgroundColor={Colors.WHITE}
          />
          <Typography variant="h5">{t("event:shuffle.progress")}</Typography>
        </Container>
        <Typography variant="caption" className="caption-text">
          {t("event:wait.few.seconds")}
        </Typography>
      </Container>
    </Popover>
  );
};

export const ShuffleInProgress = ({ eventId }: { eventId: string }) => {
  const dispatch = useAppDispatch();
  const shuffleStartTime = useShuffleStartTime(eventId);

  const now = useTicker(!!shuffleStartTime, TICKER_INTERVAL);

  useEffect(() => {
    if (!shuffleStartTime) {
      return;
    }
    const secondsUntilTimeout =
      shuffleStartTime + COUNTDOWN_LENGTH + SHUFFLE_TIMEOUT - now / 1000;
    if (secondsUntilTimeout < 0) {
      trackWarning(Warnings.SHUFFLE_TIMEOUT);
      dispatch(hideInitShuffleBanner());
    }
  }, [dispatch, now, shuffleStartTime]);

  return <ShuffleInProgressComponent />;
};
